export default __webpack_public_path__ + "static/media/icon-reload-orange.aa264c02.jpg";